import { combineReducers } from "redux"
import songsReducer from "./songsReducer"
import authReducer from "./authReducer"
import dataReducer from "./dataReducer"
// import playlistReducer from "./playlistReducer"

const rootState = combineReducers({
  songs: songsReducer,
  auth: authReducer,
  data: dataReducer,
  // playlist: playlistReducer
})

export { rootState }

export type RootState = ReturnType<typeof rootState>
